"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LicenseTransport = typebox_1.Type.Object({
    state: typebox_1.Type.String(),
    licenseType: typebox_1.Type.String(),
    licenseNumber: typebox_1.Type.String(),
    expirationDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    issuingAuthority: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=licenseTransport.js.map